import React from 'react';
import styles from './NewsTopHeader.module.scss';
import plus from '../../../assets/Imagess/plusvector.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import SearchInput from '../../Atoms/Inputs/SearchInput';

const NewsTopHeader = ({
  search,
  setSearch,
  handleNewClick,
  type = 'news',
  style,
  title,
  actionButtons,

  handleCandidatesClick,
  candidatesButtonText = 'إدارة المرشحين والدفعات',
}) => {
  const primaryText =
    'news' === type
      ? 'إنشاء خبر'
      : 'newsletter' === type
      ? 'إنشاء منشورة'
      : 'gallery' === type
      ? 'إنشاء شريحة'
      : 'media' === type
      ? 'إنشاء ألبوم'
      : 'event' === type
      ? 'إنشاء فعالية'
      : 'slider' === type
      ? 'إنشاء شريط'
      : 'statistics' === type
      ? 'إنشاء إحصائية'
      : 'إنشاء جديد';

  return (
    <div className={styles['icon-container']} style={{ ...style }}>
      {title ? (
        title
      ) : (
        <div>
          {'gallery' !== type && (
            <SearchInput search={search} setSearch={setSearch} />
          )}
        </div>
      )}

      <div className={styles['icon-subcontainer']}>
        {actionButtons}

        {type === 'statistics' &&
          typeof handleCandidatesClick === 'function' && (
            <Buttons
              text={candidatesButtonText}
              icon={plus}
              rounded={true}
              color='rgba(13, 160, 110, 1)'
              handleOnClick={handleCandidatesClick}
              type='button'
            />
          )}

        <Buttons
          text={primaryText}
          icon={plus}
          rounded={true}
          color='rgba(13, 160, 110, 1)'
          handleOnClick={handleNewClick}
          type='submit'
        />
      </div>
    </div>
  );
};

export default NewsTopHeader;
